export default __webpack_public_path__ + "static/2_25-960f023d3c5c3c50999909d00580d4d8.png";